// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"168":"skill","242":"project","443":"about"}[chunkId] + "." + {"168":"91547da6","242":"b81bb314","443":"63be6074"}[chunkId] + ".css";
};